import MmenuLight from 'mmenu-light/esm/core/index';

// mmenu Light
// https://mmenujs.com/mmenu-light/docs.html
function MobileMenu( menuID ){

    const mobile_menu = document.getElementById( menuID );

    if( mobile_menu ){

        const menu = new MmenuLight( mobile_menu, "(max-width: 1024px)" ); // set breakpoint when mobile menu opens
        
        menu.navigation({
            title: "Menu", // Title at the top of mobile menu
            theme: "dark" // light or dark
        });

        const drawer = menu.offcanvas({ 
            position: "right" // open to left or right
        });
        
        document.querySelector( '.menu-toggle' ).addEventListener( 'click', function(e){
            e.preventDefault();
            drawer.open();
        });
    }
}

export { MobileMenu };